import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

type InputSliderType = {
  label?: string;
  value: number;
  max?: number;
  min?: number;
  step?: number;
  prefix?: string;
  onChange: (val: number) => void;
  rightContent?: React.ReactNode;
};

export default function InputSlider({
  label,
  value: defaultValue,
  max = 100,
  min = 1,
  step = 1,
  onChange,
  rightContent,
}: InputSliderType) {
  const [value, setValue] = useState<number>(defaultValue);

  const sanitizeValue = (val: number) => {
    if (value < min) {
      return min;
    } else if (value > max) {
      return max;
    }
    return val;
  };

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  return (
    <>
      {!!label && <div className='mb-1 md:mt-4'>{label}</div>}
      <div className={clsx('flex gap-x-2', !!label && 'mt-2')}>
        <Slider
          value={[sanitizeValue(value)]}
          defaultValue={[value]}
          max={max}
          min={min}
          step={step}
          className='w-full'
          onValueChange={(val) => {
            setValue(val[0]);
            onChange(val[0]);
          }}
        />
        <Input
          name='fontSize'
          type='text'
          size={8}
          className='flex !h-[26px] justify-end !rounded-[6px] !py-0 pl-2 text-right text-xs'
          value={value}
          rightContent={rightContent}
          onChange={(e) => {
            const formatted = e.target.value?.replace(/[^0-9]/g, '');
            setValue(Number(formatted || 0));
          }}
          onBlur={() => {
            const tempValue = sanitizeValue(value) as number;
            setValue(tempValue);
            onChange(tempValue);
          }}
        />
      </div>
    </>
  );
}
